import axios from 'axios';

export const extractErrorMessage = (error: unknown) => {
	if (axios.isAxiosError(error)) {
		return error.response?.data?.message;
	}

	if (error instanceof Error) {
		return error.message;
	}

	if (typeof error === 'string') {
		return error;
	}

	return 'Error desconegut!';
};
